const gameStateKey = 'gameState'
const highContrastKey = 'highContrast'

type StoredGameState = {
  guesses: string[]
  solution: string
}

export const saveGameStateToLocalStorage = (gameState: StoredGameState) => {
  // console.log('saveGameStateToLocalStorage', gameState);
  
  localStorage.setItem(gameStateKey, JSON.stringify(gameState))
}

export const loadGameStateFromLocalStorage = () => {
  const state = localStorage.getItem(gameStateKey)
  // console.log('state', state);
  
  return state
    ? (JSON.parse(state) as StoredGameState)
    : {
        guesses: [],
        solution: '',
      }
}

const gameStatKey = 'gameStats'

export type GameStats = {
  winDistribution: number[]
  gamesFailed: number
  currentStreak: number
  bestStreak: number
  totalGames: number
  successRate: number
}

// Stats used to live under one global 'gameStats' key with no newsroom in it. Because
// 14 of 15 customers are served from newsword.ai, a reader who played two of our
// newsrooms saw ONE merged number presented to them as that newsroom's streak. Now
// each newsroom keeps its own.
const statKeyFor = (company?: string) =>
  company ? `${gameStatKey}:${company}` : gameStatKey

export const saveStatsToLocalStorage = (gameStats: GameStats, company?: string) => {
  try {
    localStorage.setItem(statKeyFor(company), JSON.stringify(gameStats))
  } catch (e) {
    // A browser refusing storage must not stop the game. This used to throw inside a
    // promise with no catch, freezing the reader on their winning guess.
  }
}

export const loadStatsFromLocalStorage = (company?: string) => {
  try {
    const scoped = localStorage.getItem(statKeyFor(company))
    if (scoped) {
      return JSON.parse(scoped) as GameStats
    }
    // First time we have seen this newsroom on this browser: carry the old shared
    // number across rather than dropping the reader to zero. Their other newsrooms
    // inherit the same starting point, which is what they were already being shown.
    const legacy = localStorage.getItem(gameStatKey)
    return legacy ? (JSON.parse(legacy) as GameStats) : null
  } catch (e) {
    return null
  }
}

export const setStoredIsHighContrastMode = (isHighContrast: boolean) => {
  if (isHighContrast) {
    localStorage.setItem(highContrastKey, '1')
  } else {
    localStorage.removeItem(highContrastKey)
  }
}

export const getStoredIsHighContrastMode = () => {
  const highContrast = localStorage.getItem(highContrastKey)
  return highContrast === '1'
}
